import React, { Component } from 'react';

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import { getNewChartData, getDatasourceAndDates } from '../../../api';
import { largeSize, xlsxCustomExport } from '../utils/chartConfig';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

const IMG_URL = process.env.IMG_FULL_URL;

class PrevalenceOfDiseasesChart extends Component {
    constructor(props){
        super(props);

        let selectedType = this.props.selectedIndicator != undefined ? this.props.selectedIndicator :  this.props.chartType[0].type;

        let title = "Title";
        if(this.props.title){
            title = this.props.title;
        }else{
            if(this.props.chartType != undefined){
                title = this.props.literals['L'+this.props.chartType[0].title];
            }
        }

        this.state = {
            chartConfig: {
                title: {
                    text: props.fullCountryReport == true ? '' : "<h2 class='title--card'>"+title+"</h2>",
                    align: 'left',
                    widthAdjust: 0,
                    style: {
                        zIndex: 1,
                        lineHeight:36
                    }
                },
                credits: {
                    enabled: true,
					text: "",
					href: '',
					style: {
						cursor: 'arrow'
					},
					position: {
						x: -130
					}
                },
                colors: this.props.colors,
                chart: {
                    //height: window.innerWidth > 768 ? this.props.fullCountryReport == true ? 250 : 450 : 770,
                    type: this.props.type,
                    backgroundColor: '#F0F0F0',
                    events: {
                        render: function() {
                            let chart = this;
                            if (!chart.customImage)
                            {
                                chart.customImage = chart.renderer.image(
                                   `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
                                   chart.chartWidth - 130,
                                   chart.chartHeight - 37,
                                   130,
                                   37
                                ).add();
                                chart.customImage.attr({
                                   class:'osha-logo'
                                });
                            }
                            else
                            {
                                chart.customImage.attr({
                                    x: chart.chartWidth - 130,
                                    y: chart.chartHeight - 37
                                });
                            }

                            if (chart.fullscreen.isOpen) {
                                chart.customImage.css({
                                   display: 'block'
                                });
                                chart.container.className = 'highcharts-container full-screen';
                            }
                            else
                            {
                                chart.customImage.css({
                                    display: ''
                                });	
                                chart.container.className = 'highcharts-container';
                            }
                        }					
                    },
                },
				exporting: {
					enabled: props.fullCountryReport == true ? false : true,
					buttons: {
						contextButton: {
							menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
						}
					},
                    sourceWidth: largeSize,
                    filename: title ? title.replace(/ /g, '_') : 'title',
                    menuItemDefinitions: {
                        "downloadXLS": {
                            onclick: function() {
                                xlsxCustomExport('Trend', this.series, this.title.textStr);
                            }
                        }
                    }
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						}
					}
				},
                legend:{
                    verticalAlign: 'bottom',
                    symbolRadius: 0,
                    itemMarginTop:4,
                    itemMarginBottom:4,
                    itemStyle: {
                        fontFamily: 'OpenSans',
                        fontWeight: 'normal',
                        fontSize:'12px',
                        textOverflow: "ellipsis",
                        width: 250
                    }
                },
                yAxis: {
                    gridLineColor: '#FFF',
                    gridLineWidth: 2,
                    startOnTick: true,
                    endOnTick: true,
                    tickInterval: this.props.step ? this.props.step : null,
                    max: this.props.yAxisMax ? this.props.yAxisMax : null,
                    title: {
                        text: ''
                    },
                    labels: {
                        format: this.props.percentage === true ? '{value}%' : `{value}`,
                        style: {
                            fontFamily: 'OpenSans-bold',
                            fontWeight: 'normal',
                            fontSize:  this.props.fullCountryReport ? '10px' : '12px',
                            textOverflow: 'none'
                        }
                    }
                },
                xAxis: {
                    lineWidth: 0,
                    labels: {	
                        style: {
                            fontFamily: 'OpenSans-bold',
                            fontWeight: 'normal',
                            fontSize: this.props.fullCountryReport ? '10px' : '12px' ,
                            textOverflow: 'none'
                        }
                    }
                },
				tooltip: {},
                plotOptions: {},
                series: []
            },
            isLoading: false,
            selectedTypeChart: selectedType
        }
    }

    onChangeSelect = (e) => {
        this.props.callbackDiseasesSource(e.target.value);
        this.setState({ selectedTypeChart: e.target.value });

        const serie = this.props.chartType.find((chart) => chart.type == e.target.value);
        if (window.innerWidth > 768 ) {
            this.setState({ 
                chartConfig: {
                    ...this.state.chartConfig, 
                    title: {
                        ...this.state.chartConfig.title, 
                        text: this.props.fullCountryReport == true ? '' : "<h2 class='title--card'>"+this.props.literals[`L${serie.title}`]+"</h2>" 
                    },
                    exporting: {
                        ...this.state.chartConfig.exporting, 
                        filename: this.props.literals[`L${serie.title}`].replace(/ /g, '_')
                    }
                } 
            })
        }
    }

    getLoadData(chartType){
        let categories = [];
        let series = [];
        let chart = [];

        if(chartType){
            chart = chartType.find((chart) => chart.type == this.state.selectedTypeChart);

            if (this.state.selectedTypeChart == 'deaths' && chartType.length == 1)
            {
                chart = chartType[0];
            }
            this.getCredits(chart.chart);

            let requestFilter = {
                chart: chart.chart,
                indicator: chart.chartIndicator,
                illness: chart.illness
            }
            getNewChartData(requestFilter)
                .then((data) => {
                    if(data.resultset){
                        categories = data.resultset.xAxisCategories;
                        
                        try {
                            this.setState({ ...this.state, isLoading: true });
                            
                            data.resultset.data.forEach(element => {
                                series.push({name: element.name, data: element.data});
                            });
                            
                        } catch (error) {
                            console.log('error fetching data', error)
                        } finally {
                            this.setState({ ...this.state, isLoading: false })
                        }

                        const selectedCountryColors = ['#F6A400','#F3C564'];
                        
                        for(let i = 0; i < categories.length; i++){
                            if(categories[i].includes(this.props.country)){
                                series[0].data[i] = {...series[0].data[i], color: selectedCountryColors[0], y: series[0].data[i]};
                                if(series[1]){
                                    series[1].data[i] = {...series[1].data[i], color: selectedCountryColors[1], y: series[1].data[i]}
                                }
                            } else if(!categories[i].includes('EU27_2020') && !categories[i].includes('EU28')
                                    && !categories[i].includes("EU27")){
                                series[0].data[i] = {...series[0].data[i], color: this.props.colors[0], y: series[0].data[i]}
                                if(series[1]){
                                    series[1].data[i] = {...series[1].data[i], color: this.props.colors[1], y: series[1].data[i]}
                                }
                            }
                        }

                        this.setState({
                            chartConfig: {...this.state.chartConfig, 
                                xAxis: {
                                    categories,
                                    plotLines: [
                                        {
                                            color: 'black',
                                            width: 2,
                                            value: 0.5,
                                            id: 'break-eu',
                                            zIndex:1
                                        }
                                    ],
                                },
                                tooltip: {
                                    useHTML: true,
                                    borderColor:"#529FA2",
                                    style: {
                                        opacity: 1,
                                        zIndex: 100
                                    },
                                    formatter: function () {
                                        let chartTitle = this.series.chart.title.textStr;
                                        let numberOfDecimals = 1;
                                        if (chartTitle.indexOf("DALY") > -1)
                                        {
                                            numberOfDecimals = 0;
                                        }
                                        return '<ul class="tooltip-item">'+
                                        '<li><strong>Trend: </strong> ' + this.series.name + '</li>' +
                                        '<li><strong>Country: </strong> '+ this.point.category + '</li>' +
                                        '<li><strong class="tooltip-value up">Value: </strong> '+ Highcharts.numberFormat(this.y,numberOfDecimals,',','.') + '</li>' +
                                        '</ul>';
                                    }
                                },
                                plotOptions: {
                                    series: {
                                        pointPadding: 0.11,
                                        groupPadding: 0.15,
                                        borderWidth: 0,
                                        pointStart: 0
                                    },
                                }, 
                                series
                            }
                        })
                    }
                })
        }
        
    }

    getCredits = (chart) => {
        getDatasourceAndDates(chart).then((res)=>{
            let text = res;
            this.setState({
                chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, text}}
            })
        })		
    }

    componentDidMount(){
        this.getLoadData(this.props.chartType);
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.selectedTypeChart != this.state.selectedTypeChart || prevProps.chartType != this.props.chartType){
            let chart = this.props.chartType.find((chart) => chart.type == this.state.selectedTypeChart);
            if (this.state.selectedTypeChart == 'deaths' && this.props.chartType.length == 1)
            {
                chart = this.props.chartType[0];
            }            
            this.setState({ 
                chartConfig: {
                    ...this.state.chartConfig, 
                    title: {
                        ...this.state.chartConfig.title, 
                        text: this.props.fullCountryReport == true ? '' : "<h2 class='title--card'>"+this.props.literals[`L${chart.title}`]+"</h2>" 
                    },
                    exporting: {
                        ...this.state.chartConfig.exporting, 
                        filename: this.props.literals[`L${chart.title}`].replace(/ /g, '_')
                    }
                } 
            })
            this.getLoadData(this.props.chartType);
        }

        if (prevProps.type != this.props.type) {
            this.setState({ chartConfig: {...this.state.chartConfig, chart: {...this.state.chartConfig.chart, type: this.props.type} } })
        }

        if(prevProps.country != this.props.country){
            this.getLoadData(this.props.chartType);
        }
    }

    render(){
        let selectDiv;
		
		if(this.props.showSelect && !this.props.fullCountryReport){
            let selectOptions = this.props.chartType.map((chart) => chart.type);
            selectDiv = (
                selectOptions.length > 1 && (
                    <div className="select-filter-chart">
                        <select onChange={this.onChangeSelect} value={this.state.selectedTypeChart} >
                            {selectOptions.map((type) => {
                                return <option key={type} value={type} > {type.toUpperCase()} </option>
                            })}
                        </select>
                    </div>
                )
            )
        }

        return(
            <React.Fragment>
                {selectDiv && (
                    <div className='chart--filters--block'>
                        {selectDiv}
                    </div>
                )}
                {!this.state.isLoading && (
                    <div className='chart-container'>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.state.chartConfig}
                            containerProps={{ className: 'chartContainer' }}
                        />
                    </div>
                )}
            </React.Fragment>
        )
    }
}

export default PrevalenceOfDiseasesChart;